<template>
  <div class="generalreport">
    <!-- <h1>开发页面</h1><small>(通用数据上报接口)</small> -->

    <div class="m-2 text-left">
      <el-divider content-position="left">上报数据项</el-divider>

      <div
        data-v-794655a4=""
        role="alert"
        class="el-alert el-alert--success"
        style="font-size: 16px;color:#5C5F1F;background-color: #89ceac;line-height:20px;height: 80px; width: 100%;margin:0 auto"
        id="textTip"
        v-show="Tag === '缺考信息' || Tag === '分科缺考信息'"
      >
      </div><br/>
      <template v-if="isData">
        <!-- 表单绑定接收到的数据对象 -->
        <el-form
          ref="PlugBody"
          :model="PlugBody"
          label-position="left"
          label-width="120px"
        >
          <!-- 循环数据对象数组 -->
          <span v-for="(item, key) in PlugBody">
            <el-form-item
              v-if="(AddrCategory.indexOf(item.title.replace('缺考','')) !== -1 && AddrCategory !== null && AddrCategory !== '' && (Tag === '缺考信息' || Tag === '分科缺考信息')) || (Tag !== '缺考信息' && Tag !== '分科缺考信息')"
              :key="key"
              :label="item.title"
            >
              <el-input
                v-if="item.enable == true"
                v-model="item.defaultValue"
                :placeholder="item.memo"
              ></el-input>
            </el-form-item>
          </span>
          <!-- 提交按钮 -->
          <el-form-item>
            <el-button class="w-100" type="success" @click="submitForm()"
              >数据上报</el-button
            >
          </el-form-item>
        </el-form>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GeneralReport',
  data () {
    return {
      isData: false,
      PlugBody: null,
      Tag: "",//获取分组名
      AddrID: "",//获取考点ID
      AddrCategory: "",//获取考试中考点所考类别
      stuNum:{}//考生数量
    };
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    GeneralReportGet () {
      this.apiGeneralReportGet({ WorkID: this.getWork().WorkID, SplitProcessID: this.SplitProcessID }, this, res => {
        // eslint-disable-next-line no-console
        // console.log("res", res)
        if (res.code == 20000) {
          // eslint-disable-next-line no-console
          // 正确返回通用数据上报值后进行处理
          this.PlugBody = {} // 将PlugBody类型更新为JSON对象
          // 以对象化的方式循环工作环节传递的数据（通用上报数据的模板）
          Object.keys(this.ProcessData.PlugJson.PlugBody).forEach((Element) => {
            // console.log(Element)
            if (Element != 'IsStatus' && Element != 'IsMemo' && Element != 'IsUpload' && this.ProcessData.PlugJson.PlugBody[Element].enable) {
              // 判断当前数据是不是对象（通用上报数据项内容是JSON对象）
              if (Object.prototype.toString.call(this.ProcessData.PlugJson.PlugBody[Element]) == '[object Object]')
                this.PlugBody[Element] = this.ProcessData.PlugJson.PlugBody[Element] // 将需要上报的数据项添加到页面变量PlugBody中
            }
          })

          Object.keys(this.PlugBody).forEach((element) => {
            if (res.data.InputJson[element]) {
              this.PlugBody[element].defaultValue = res.data.InputJson[element].value
            } else {
              this.PlugBody[element].defaultValue = ''
            }
          })
          this.isData = true
          // eslint-disable-next-line no-console
          // console.log("数据处理方法结束this.PlugBody", this.PlugBody)
          //数据处理方法结束
          this.Tag = res.Tag
          this.AddrID = res.AddrID
          this.AddrCategory = res.AddrCategory
          var category = ""
          var aCategory=this.AddrCategory.split("、")
          this.stuNum=res.StudentNum
          var totalStuNum=0
          for (let a in aCategory) {
            if (category != "") {
              category += "、"
            }
            category += aCategory[a]
            if (a.indexOf("缺考") === -1) {
              category += "缺考"
            }
            totalStuNum += res.StudentNum[aCategory[a]]
          }
          document.getElementById("textTip").innerText="缺考信息需填写"+category+"，当前考点共"+totalStuNum+"名考生，填写时请不要超过考生人数。"
        } else {
          this.$toast(res.message)
        }
      })
    },
    submitForm () {
      let reportData = {}
      Object.keys(this.PlugBody).forEach((element) => {
        reportData[element] = {}
        reportData[element].value = this.PlugBody[element].defaultValue
      })
      // console.log("reportData", reportData)
      var jsonPlugData=reportData
      var fieldname=""
      var totalNum=0
      for(var item in this.PlugBody){
        if(this.PlugBody[item].title===undefined){
          continue
        }
        var s=this.PlugBody[item].title.replace("缺考","")
        if(this.AddrCategory.indexOf(s) !== -1 && s !== ""){
          fieldname=item
          if((this.Tag==="缺考信息" || this.Tag==="分科缺考信息") && this.AddrCategory !== null && this.AddrCategory !== ''){
            var num=jsonPlugData[fieldname]['value']
            totalNum+=this.stuNum[s]
            if(num > this.stuNum[s]){
              this.$message({
                message: this.PlugBody[item].title + '超过本场考试考生人数，无法保存。',
                type: 'error'
              });
              return
            }
          }
        }
      }
      if((this.Tag==="缺考信息" || this.Tag==="分科缺考信息")&& this.AddrCategory !== null && this.AddrCategory !== ''){
        var num=jsonPlugData[fieldname]['value']
        if(num > totalNum / 2){
          this.$confirm('缺考人数已超一半，确定要保存吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.apiGeneralReportPost({ WorkID: this.getWork().WorkID, SplitProcessID: this.SplitProcessID, InputJson: reportData }, this, res => {
              this.$toast(res.message)
            })
          }).catch(
            function(){}
          )
        }
        else{
          this.apiGeneralReportPost({ WorkID: this.getWork().WorkID, SplitProcessID: this.SplitProcessID, InputJson: reportData }, this, res => {
            this.$toast(res.message)
          })
        }
      }
      else{
        this.apiGeneralReportPost({ WorkID: this.getWork().WorkID, SplitProcessID: this.SplitProcessID, InputJson: reportData }, this, res => {
          // eslint-disable-next-line no-console
          // console.log("res", res)
          // if(res.code == 20000){ } 
          this.$toast(res.message)
        })
      }
    }
  },
  created () {
    this.GeneralReportGet()
  }
}
</script>
<style scoped>
</style>